
import { apiClient } from '@/lib/mockApi';


export const useSystemMenuSync = () => apiClient;
